import React from 'react';

import { search, loadMore } from '../actions/search';
import Loader from './loader.jsx';
import { createLoader } from '../loader';
import { routeToSearch } from '../actions/route';
import connect from './connect';

import { selectResults, selectTotal } from '../selectors/search';
import { contentResource } from '../resources/content';
import Search from './search.ui.jsx';

const SearchLoader = createLoader({
    busy() {
        return <Loader message="Loading search results..." />;
    },
    component: Search,
    resources: {
        content(options) {
            if (options.props.context != null) {
                return contentResource(options.props.context, options);
            }
            return () => null;
        },
        _requestPlaceholder: {
            depends: ['content'],
            _requestPlaceholder(options) {
                const { context, queryText } = options.props;
                return {
                    id: `search`,
                    cacheKey: `${context}-${queryText}`,
                    load() {
                        return options.dispatch(search(queryText, context));
                    },
                    find() {
                        return null;
                    },
                };
            },
        },
        contentResults: {
            depends: ['_requestPlaceholder'],
            contentResults(options) {
                return () => selectResults(options.rootState, 'content');
            },
        },
        contentTotal: {
            depends: ['_requestPlaceholder'],
            contentTotal(options) {
                return () => selectTotal(options.rootState, 'content');
            },
        },
        markupResults: {
            depends: ['_requestPlaceholder'],
            markupResults(options) {
                return () => selectResults(options.rootState, 'markup');
            },
        },
        markupTotal: {
            depends: ['_requestPlaceholder'],
            markupTotal(options) {
                return () => selectTotal(options.rootState, 'markup');
            },
        },
    },
});

function mapStateToProps(state, props) {
    const { queryText, context } = props.params;
    return {
        rootState: state,
        queryText,
        context,
    };
}

export default connect(
    mapStateToProps,
    {
        routeToSearch,
        loadMore,
    },
    null,
    { pure: true }
)(SearchLoader);



// WEBPACK FOOTER //
// ./src/components/search.jsx